import { selectCurrentCompany } from "src/redux/features/user/selectors/userState.selectors";
import { useAppSelector } from "src/redux/hooks/redux";
import { getTimeZoneCity } from "../helpers/getTimeZoneCity";

export const useCompanyTimeZone = () => {
  const currentCompany = useAppSelector(selectCurrentCompany);
  const timeZone = currentCompany?.timeZone || "UTC";

  return {
    timeZone,
    city: getTimeZoneCity(timeZone),
  };
};
